export { StaleWork } from './components/StaleWork'
